
import find from "lodash/find";
import { t } from "./localization";
import { RESULTS, COMPETITION_METRIC } from "../Components/UIKit/UIKit";
import { IHistoryResult, WarSettingsLeague } from "../Reducers/ReducerClanWars";

export const MEDALS_MAP = {
  [1]: {
    name: t('Лучший экипаж') // High Crew
  },
  [2]: {
    name: t('Морские волки') // Sea Dogs
  },
  [3]: {
    name: t('Ветераны') // Veterans
  },
  [4]: {
    name: t('Старая гвардия') // Old Guard
  },
  [5]: {
    name: t('Последний рубеж') // The Last Stand
  }
};

export const getLeagueData = (leagues: Array<WarSettingsLeague>, leagueNumber: number): WarSettingsLeague => {
  const league = find(leagues, league => league.number === leagueNumber);
  return league || {
    icons: {
      default: ''
    },
    number: 0,
    points: [],
    title: ''
  };
};

export const getCompetitionMetricPoints = (competitionMetric: string) => {
  switch (competitionMetric) {

    case COMPETITION_METRIC.EXP:
      {
        return t('Заработанный чистый опыт');
      }

    case COMPETITION_METRIC.DAMAGE:
      {
        return t('Нанесенный урон');
      }

    case COMPETITION_METRIC.RIBBONS:
      {
        return t('Количество лент');
      }

    default:
      {
        return t('Заработанный чистый опыт');
      }

  }
};

export const getOwnResult = (results: Array<IHistoryResult>, clanId: number): IHistoryResult | null => {
  if (!clanId) {return null;}
  let result = results.filter(r => r && r.clanId === clanId);
  if (result[0]) {
    return result[0];
  } else {
    return null;
  }
};

export const checkWin = (results: Array<IHistoryResult>, clanId: number) => {
  if (!clanId) {return false;}
  const res = getOwnResult(results, clanId);
  if (res) {
    return res.isWinner;
  } else {
    return false;
  }
};

export const checkDraw = (results: Array<IHistoryResult>) => {
  let prevRes: IHistoryResult | null = null;
  let isDraw = true;

  for (let index = 0; index < results.length; index++) {
    const res = results[index];
    if (!res || !isDraw) {return;}
    if (index === 0) {
      prevRes = res;
    } else {
      if (prevRes !== null && res.isWinner === prevRes.isWinner) {
        prevRes = res;
      } else {
        isDraw = false;
      }
    }
  }
  return isDraw;
};


export const getResult = (results: Array<IHistoryResult>, clanId: number) => {
  if (checkWin(results, clanId)) {
    return RESULTS.WIN;
  } else if (checkDraw(results)) {
    return RESULTS.DRAW;
  } else {
    return RESULTS.DEFEAT;
  }
};

export const getVersusTitle = (result: string) => {
  switch (result) {
    case RESULTS.WIN:
      {
        return t('Победа');
      }

    case RESULTS.DEFEAT:
      {
        return t('Поражение');
      }

    case RESULTS.DRAW:
      {
        return t('Ничья');
      }

    default:
      {
        return '';
      }

  }
};